import { createSlice } from "@reduxjs/toolkit";
import VwRezervbarkod1DTO from "src/models/Rezervbarkod/VwRezervbarkod01DTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

interface IRezervBarkod {
    open: boolean;
    activeRow: VwRezervbarkod1DTO;
    detailOpen: boolean;
    kurumId?: number;
};
export const rezervBarkodSlice = createSlice<IRezervBarkod, MapReducerPayloads<IRezervBarkod, {
    setOpen: boolean;
    setActiveRow: VwRezervbarkod1DTO;
    setDetailOpen: boolean;
    setKurumId?: number;
}>>({
    name: "rezervBarkod",
    initialState: {
        open: false,
        activeRow: new VwRezervbarkod1DTO(),
        detailOpen: false,
        kurumId: null,
    },
    reducers: {
        setOpen: (state, action) => { state.open = action.payload; },
        setActiveRow: (state, action) => { state.activeRow = action.payload; },
        setDetailOpen: (state, action) => { state.detailOpen = action.payload; },
        setKurumId: (state, action) => { state.kurumId = action.payload; },
    },
});